import { FilterModal } from '../components/inventory/category-modal.vue.js';
Vue.component('category-modal', FilterModal);
